<script setup lang="ts">
import { ref, computed, inject } from "vue";
import { TranslationService } from "../services/translation.service";

const t = (inject<TranslationService>("translationSvc") as TranslationService)
    .t;

const { teamEntries, categories } = defineProps({
    teamEntries: {
        type: Array,
        required: true,
    },
    categories: {
        type: Array,
        required: true,
    },
});

const chosenCategory = ref("");

const filteredTeamEntries = computed(() => {
    // check if consultantAreaCategories contains chosenCategory
    return teamEntries.filter(
        (item) =>
            item.consultantAreaCategorySlugs.includes(chosenCategory.value) ||
            chosenCategory.value === "",
    );
});

const changeCategory = (category) => {
    // Implement the logic to change the category
    chosenCategory.value = category;
};
</script>

<template>
    <div class="grid grid-cols-24">
        <div class="col-start-3 col-end-23" v-if="categories.length > 0">
            <div class="mb-12 mt-12">
                <ul
                    class="flex gap-4 md:gap-8 border-b border-grey-200 overflow-x-auto"
                >
                    <li
                        class="border-b-4 border-transparent px-2 py-2 cursor-pointer"
                        v-for="(item, index) in categories"
                        :class="{
                            '!border-primary': chosenCategory === item.slug,
                        }"
                        @click="changeCategory(item.slug)"
                    >
                        <span class="text-nowrap">
                            {{ item.title }}
                        </span>
                    </li>
                </ul>
            </div>
        </div>

        <div class="col-start-3 col-end-23">
            <div
                class="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-12"
            >
                <div class="" v-for="item in filteredTeamEntries">
                    <div
                        class="bg-no-repeat bg-center bg-cover pt-full w-full rounded-md mb-4"
                        :style="{
                            backgroundImage: item.mainImage
                                ? 'url(' + item.mainImage + ')'
                                : '',
                        }"
                    ></div>

                    <div class="font-bold mb-4" v-if="item.jobPosition">
                        {{ item.jobPosition }}
                    </div>

                    <div class="text-f3 font-bold mb-4">{{ item.title }}</div>
                    <div class="mb-4 font-light" v-if="item.ausbildung">
                        {{ item.ausbildung }}
                    </div>

                    <div class="mb-4 font-light" v-if="item.consultantRegions">
                        Areas:<br />
                        {{ item.consultantRegions }}
                    </div>

                    <a :href="'mailto:' + item.email">
                        <i class="text-primary far fa-envelope"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
